/// KL-50
export enum SelfControlSystem {
	RVASVT = 1,
	GHP = 2,
	GGP = 3,
	Other = 4,
}
